import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const PasswordReset = loadable(() => import(/* webpackChunkName: "PasswordReset" */ './PasswordReset'), {
  fallback: <LoadableFallback visible />,
});

const asyncPasswordReset = ({ route }) => (
  <PasswordReset route={route} />
);

asyncPasswordReset.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncPasswordReset;
